import { useEffect, useRef } from "react";
import horizonLogo from "@/assets/horizon-nj-health-logo.jpg";
import ameriHealthLogo from "@/assets/amerihealth-logo.png";
import uhcLogo from "@/assets/uhc-wordmark-stacked-blue-wshield.svg";

const insurers = [
  { name: "Horizon NJ Health", logo: horizonLogo },
  { name: "AmeriHealth", logo: ameriHealthLogo },
  { name: "UnitedHealthcare", logo: uhcLogo },
];

export default function InsurancePartners() {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("visible")),
      { threshold: 0.1 }
    );
    const items = ref.current?.querySelectorAll(".animate-on-view");
    items?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="insurance"
      data-testid="insurance-section"
      className="ez-section bg-ez-blue-light"
      ref={ref}
    >
      <div className="ez-container">
        <div className="animate-on-view text-center mb-12">
          <div className="inline-block text-ez-teal font-semibold font-caveat text-lg mb-3">
            We Accept
          </div>
          <h2 className="font-outfit text-2xl md:text-3xl font-bold text-ez-text">
            Preferred <span className="text-ez-teal">Insurance Plans</span>
          </h2>
          <p className="text-ez-muted mt-4 max-w-xl mx-auto font-jakarta">
            EZ Care Pharmacy accepts a wide range of insurance plans to make your care as affordable as possible.
          </p>
        </div>

        <div className="animate-on-view flex flex-wrap justify-center items-center gap-8 md:gap-14" style={{ transitionDelay: "0.15s" }}>
          {insurers.map((ins) => (
            <div
              key={ins.name}
              className="bg-white rounded-2xl shadow-sm border border-gray-100 px-8 py-6 flex items-center justify-center hover:shadow-md transition-shadow duration-300"
              style={{ minWidth: "180px", maxWidth: "240px" }}
            >
              <img
                src={ins.logo}
                alt={ins.name}
                className="h-14 w-auto object-contain"
              />
            </div>
          ))}
        </div>

        <p className="animate-on-view text-center text-ez-muted text-sm font-jakarta mt-10" style={{ transitionDelay: "0.3s" }}>
          Don't see your insurance? <a href="tel:+18625201063" className="text-ez-teal font-semibold hover:underline">Call us</a> — we accept many more plans.
        </p>
      </div>
    </section>
  );
}
